var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-list"},_vm._l((_vm.videoList),function(v){return _c('video-item',{key:v,staticClass:"video-item",attrs:{"videoID":v}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }